import React from 'react';
import styled from 'styled-components';

const PlaceholderImage = styled.div`
    background-image: url('../../../../assets/images/no-messages.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;
    width: 100%;
    height: 200px;
`;

const EmptyStateContainer = styled.div`
    text-align: center;
    padding-top: 10px;
    border-top: 1px solid #e5e5e5;
    h4 {
        font-size: 18px;
        font-weight: 500;
        color: #000000;
    }
    p {
        font-size: 14px;
        color: #000000;
    }
`;

const EmptyState = ({ message = '' }) => {
    return (
        <EmptyStateContainer>
            <h4>{message}</h4>
            <PlaceholderImage />
        </EmptyStateContainer>
    );
};

export { EmptyState };
